import React from 'react';
import { motion } from 'motion/react';
import { Gavel, CheckCircle2, AlertTriangle, HelpCircle, RotateCcw } from 'lucide-react';

const Card = ({ title, icon: Icon, children }: { title: string, icon: any, children: React.ReactNode }) => (
  <div className="bg-white dark:bg-slate-900 border border-line dark:border-slate-800 p-8 rounded-[2rem] shadow-sm mb-6">
    <div className="flex items-center gap-4 mb-6">
      <div className="w-10 h-10 bg-slate-50 dark:bg-slate-800 rounded-xl flex items-center justify-center text-accent">
        <Icon className="w-5 h-5" />
      </div>
      <h3 className="font-bold text-lg dark:text-white uppercase-none">{title}</h3>
    </div>
    <div className="text-slate-500 dark:text-slate-400 text-sm leading-relaxed space-y-4">
      {children}
    </div>
  </div>
);

export default function TermsOfService() {
  return (
    <motion.div 
      initial={{ opacity: 0, scale: 0.98 }}
      animate={{ opacity: 1, scale: 1 }}
      className="p-6 md:p-20 max-w-4xl mx-auto"
    >
      <header className="mb-16 text-center">
        <div className="w-20 h-20 bg-accent/10 text-accent rounded-3xl flex items-center justify-center mx-auto mb-8">
          <Gavel className="w-10 h-10" />
        </div>
        <h1 className="text-5xl font-black tracking-tight dark:text-white mb-4 italic">Terms of Service</h1>
        <p className="text-slate-400 font-bold uppercase tracking-widest text-[10px]">Please read our conditions carefully before using our engine.</p>
      </header>

      <div className="grid grid-cols-1 gap-6">
        <Card title="1. Acceptance of Terms" icon={CheckCircle2}>
          <p>By accessing and using QuicklyUtils, you accept and agree to be bound by the terms and provision of this agreement.</p>
          <p>If you do not agree to abide by the above, please do not use this service.</p>
        </Card>

        <Card title="2. Provision of Service" icon={RotateCcw}>
          <p>QuicklyUtils is an open toolset provided "as is". We reserve the right to modify or discontinue tools, features, or any part of the service at any time without notice.</p>
        </Card>

        <Card title="3. User Responsibilities" icon={HelpCircle}>
          <p>Users are responsible for ensuring that their use of our tools complies with their local laws and regulations. You may not use our tools for any illegal or unauthorized purpose.</p>
          <p>Misuse of AI tools (like the Rewriter) to generate harmful or deceptive content is strictly prohibited.</p>
        </Card>

        <Card title="4. Limitation of Liability" icon={AlertTriangle}>
          <p>QuicklyUtils and its creators shall not be liable for any direct, indirect, incidental, or consequential damages resulting from the use or inability to use our tools.</p>
          <p>Accuracy of results generated by AI or conversion tools should always be double-checked by the user.</p>
        </Card>
      </div>

      <footer className="mt-16 text-center text-slate-400 text-[10px] font-bold uppercase tracking-[0.2em]">
        Last Modified: April 2026
      </footer>
    </motion.div>
  );
}
